// export const baseUrl = 'https://bbydapi.bandahudong.com'
// console.log(baseUrl)

console.log("环境", process.env.NODE_ENV);
console.log("域名地址", process.env.API_ROOT);
const baseUrl = process.env.API_ROOT;
export default {
  baseUrl: baseUrl, // 基础地址
  common:{
    babujoin: baseUrl + "/h5/babu/index/join",
    listen: baseUrl + "/h5/babu/index/listen",//预约试听
    sendVerify: baseUrl + "/h5/babu/index/sendVerify",//发送验证码
    categoryList: baseUrl + "/h5/babu/article/categoryList",//栏目列表
    articleList: baseUrl + "/h5/babu/article/list",//文章列表
    articleView: baseUrl + "/h5/babu/article/view",//文章详情

  },
  
 
};



// WEBPACK FOOTER //
// ./src/common/api.js